import { z } from "zod";
import { defineEvent } from "./registry.js";
export const demoNoteCreatedV1 = defineEvent({
    type: "demo.note.created",
    version: 1,
    description: "Demo notu oluşturuldu (referans modül)",
    realtime: ["tenant"],
    payload: z.object({ noteId: z.uuid(), noteNo: z.string(), title: z.string() }),
});
export const demoNoteStatusChangedV1 = defineEvent({
    type: "demo.note.status_changed",
    version: 1,
    description: "Demo notunun durumu değişti (referans modül)",
    realtime: ["tenant"],
    payload: z.object({ noteId: z.uuid(), from: z.string(), to: z.string() }),
});
//# sourceMappingURL=demo-notes.v1.js.map